module.exports = __webpack_public_path__ + "static/favicon-34c06f76c338bf8a774df1c902e8fbd9.png";